import React, { useEffect } from "react";
import { MDBCol } from "mdbreact";

const TwitterBase = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    script.charset = "utf-8";
    script.async = true;
    document.getElementsByClassName("twitter-embed")[0].appendChild(script);
  }, []);

  return (
    <MDBCol md="4">
      <div className="twitter-embed">
        <h4 className="text-center text-bold">Tweets</h4>
        <a
          data-cards="hidden"
          href="https://twitter.com/dominion_radio?ref_src=twsrc%5Etfw"
          className="twitter-timeline"
          // data-tweet-limit="5"
          // data-card="false"
          data-chrome="noheader nofooter noborders"
        >
          Tweets by dominion_radio
        </a>
      </div>
    </MDBCol>
  );
};

export default TwitterBase;
